import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountQuery } from 'restful/accounts/queries/useAccount';
import { restCall } from 'services/api/restful/client';
import { RestApiError } from 'services/api/restful/errors';
import { linkLoyaltyAccount } from 'services/api/restful/generated/accounts/accounts';
import type {
  SaudiRewardsBalance,
  SaudiRewardsLink,
} from 'services/api/restful/generated/nofomoRestApi.schemas';

export const useLinkSaudiRewardsAccount = () => {
  const queryClient = useQueryClient();

  const { isPending, isPaused, mutate } = useMutation<
    SaudiRewardsBalance,
    RestApiError,
    SaudiRewardsLink
  >({
    mutationFn: async (input) => {
      const { data } = await restCall(() => linkLoyaltyAccount(input));
      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: accountQuery.queryKey });
      queryClient.setQueryData(accountQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            ...oldData,
            account: {
              ...oldData?.account,
              saudiRewardsMemberId: data.memberId ?? '',
            },
          };
        }
      });
    },
  });

  return {
    linkSaudiRewardsAccount: mutate,
    isLoading: isPending && !isPaused,
  };
};
